import React from 'react'
// import inputComponents from './inputComponents'
import { checkTextTranslation, deepInstantOfObject, getObject, imageAddress, priceStandardView, setObject, translate } from '../../utils/useful'
// import PriceInput from './PriceInput'
// import TextInput from './TextInput'
import SidebarView from '../SidebarView'
// import FixedView from '../FixedView'
import RowTableInvoice from './RowTabeInvoice'
import Collapsible from 'react-collapsible'
import { v4 as uuidv4 } from "uuid";
import Responsive from '../Responsive'
import CommerceInvoiceCalculations from '../CommerceInvoiceCalculations'
import FullfilmentSelectInput from './FullfilmentSelectInput'
import { ObjectId } from 'bson';
import SubformInput from './SubformInput'
import HttpServices from '../../utils/Http.services'

class InventoryInput extends React.Component {
    state = {
        errors: {},
        data: {},
        width: window.innerWidth,
        tab: 1,
        sourceSections: [],
        destinationSections: [],

        baseFields: [
            { key: 'product', type: 'ProductSelectInput', col: '4', information: { label: '{{lang}}Item', address: 'getProducts', filter: { appletHub: '{{appletHub}}', applet: '{{applet}}' }, fields: { title: 'name', image: 'media', value: '_id', price: 'price', unit: 'unit', includesVariants: "includesVariants", variants: 'variants', additionals: "additionals" }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: true, autoFocus: true }, showMain: true },
            // { key: 'quantity', type: 'NumberInput', col: '4', information: { label: '{{lang}}Quantity', placeholder: '{{lang}}Quantity', required: true } },
        ],

        allFields: {
            product: { key: 'product', type: 'ProductSelectInput', col: '4', information: { label: '{{lang}}Item', address: 'getProducts', filter: { appletHub: '{{appletHub}}', applet: '{{applet}}' }, fields: { title: 'name', image: 'media', value: '_id', price: 'price', unit: 'unit', includesVariants: "includesVariants", variants: 'variants', additionals: "additionals" }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: true, autoFocus: true }, showMain: true },
            quantity: { key: 'quantity', type: 'NumberInput', col: '2', information: { label: '{{lang}}Quantity', placeholder: '{{lang}}useful.count', required: true } },
            costPerUnit: { key: 'costPerUnit', type: 'PriceInput', col: '3', information: { label: '{{lang}}Cost/Unit', disabled: false, placeholder: '{{lang}}useful.amount', required: true } },

            sourceSection: { key: 'sourceSection', type: 'SelectInput', col: '3', information: { label: '{{lang}}From Section', type: 'local', isSearchable: true, items: [], placeholder: '{{lang}}Select ...', required: true }, showMain: true },
            sourceStatus: { key: 'sourceStatus', type: 'SelectInput', col: '3', section: 'sec-info', information: { label: '{{lang}}From status', type: 'local', items: [{ value: 'available', title: '{{lang}}Available' }, { value: 'reserved', title: '{{lang}}Reserved' }, { value: 'inTransit', title: '{{lang}}In Transit	' }, { value: 'inReceiving	', title: '{{lang}}In Receiving' }, { value: 'ordered', title: '{{lang}}Ordered' }, { value: 'backordered', title: '{{lang}}Backordered' }, { value: 'quarantine', title: '{{lang}}Quarantine' }, { value: 'consignment', title: '{{lang}}Consignment' }, { value: 'loaned', title: '{{lang}}Loaned' }, { value: 'damaged', title: '{{lang}}Damaged' }, { value: 'expired', title: '{{lang}}Expired' }, { value: 'inProduction', title: '{{lang}}In Production' }, { value: 'disposed', title: '{{lang}}Disposed' }], placeholder: '{{lang}}type', required: true } },

            destinationSection: { key: 'destinationSection', type: 'SelectInput', col: '3', information: { label: '{{lang}}To Section', type: 'local', isSearchable: true, items: [], placeholder: '{{lang}}Select ...', required: true }, showMain: true },
            destinationStatus: { key: 'destinationStatus', type: 'SelectInput', col: '3', section: 'sec-info', information: { label: '{{lang}}To status', type: 'local', items: [{ value: 'available', title: '{{lang}}Available' }, { value: 'reserved', title: '{{lang}}Reserved' }, { value: 'inTransit', title: '{{lang}}In Transit	' }, { value: 'inReceiving	', title: '{{lang}}In Receiving' }, { value: 'ordered', title: '{{lang}}Ordered' }, { value: 'backordered', title: '{{lang}}Backordered' }, { value: 'quarantine', title: '{{lang}}Quarantine' }, { value: 'consignment', title: '{{lang}}Consignment' }, { value: 'loaned', title: '{{lang}}Loaned' }, { value: 'damaged', title: '{{lang}}Damaged' }, { value: 'expired', title: '{{lang}}Expired' }, { value: 'inProduction', title: '{{lang}}In Production' }, { value: 'disposed', title: '{{lang}}Disposed' }], placeholder: '{{lang}}type', required: true } },

            // section: { key: 'section', type: 'SelectInput', col: '3', information: { label: '{{lang}}Section', type: 'local', isSearchable: true, items: [], placeholder: '{{lang}}Select ...', required: true }, showMain: true },
            // status: { key: 'status', type: 'SelectInput', col: '3', section: 'sec-info', information: { label: '{{lang}}Status', type: 'local', items: [{ value: 'available', title: '{{lang}}Available' }, { value: 'reserved', title: '{{lang}}Reserved' }, { value: 'inTransit', title: '{{lang}}In Transit	' }, { value: 'inReceiving	', title: '{{lang}}In Receiving' }, { value: 'ordered', title: '{{lang}}Ordered' }, { value: 'backordered', title: '{{lang}}Backordered' }, { value: 'quarantine', title: '{{lang}}Quarantine' }, { value: 'consignment', title: '{{lang}}Consignment' }, { value: 'loaned', title: '{{lang}}Loaned' }, { value: 'damaged', title: '{{lang}}Damaged' }, { value: 'expired', title: '{{lang}}Expired' }, { value: 'inProduction', title: '{{lang}}In Production' }, { value: 'disposed', title: '{{lang}}Disposed' }], placeholder: '{{lang}}type', required: true } },

            valueAdjustment: { key: 'valueAdjustment', type: 'PriceInput', col: '3', information: { label: '{{lang}}Cost Adjustment', negativeAllowed: true, disabled: false, placeholder: '{{lang}}e.g. +0.25 or -0.10', required: true } },
            quantityAdjustment: { key: 'quantityAdjustment', type: 'NumberInput', col: '3', information: { label: '{{lang}}Quantity Adjustment', disabled: false, placeholder: '{{lang}}e.g. +12 or -8', required: true } },

        },

        fields: []
    }

    componentDidMount() {
        this.setState({ show: true })
        setTimeout(() => {
            this.createEntries()
        }, 10)
        // window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.setFormWidth)
        this.checkRelatedFields()
    }

    componentDidUpdate(prevProps) {

        if (prevProps.fullData != this.props.fullData) {
            this.checkRelatedFields()
        }

    }


    checkRelatedFields = () => {

        let fullData = this.props.fullData
        let information = this.props.header?.information
        let relatedFields = this.state.relatedFields ?? {}

        if (information.relatedFields) {
            Object.entries(information.relatedFields).map(([key, value]) => {
                if (relatedFields[key] != getObject(fullData, value)) {

                    relatedFields[key] = getObject(fullData, value)

                    if (key == 'source') {
                        this.getWarehouseSections(getObject(fullData, value), 'sourceSections')
                    }

                    if (key == 'destination') {
                        this.getWarehouseSections(getObject(fullData, value), 'destinationSections')
                    }

                    if (key == 'type') {
                        this.typeChanged(getObject(fullData, value), getObject(fullData, information?.relatedFields?.subType))
                    }
                }
            })
        }

        this.setState({ relatedFields }, () => {
            this.createFields()
        })

    }


    createEntries = () => {

        let entries = this.props.data ?? []
        // console.log("createEntries", entries)
        if (entries.length < 1) {
            let length = (1 - entries.length)
            for (let i = 0; i < length; i++) {
                entries.push({ product: null, })
            }
        }


        this.calculateTotals(entries)
        this.props.changeValue(this.props.header.key, entries, this.props.extra)

    }

    typeChanged = (type, subType) => {

        let hasSource = false
        let hasDestination = false
        console.log(type, subType)
        console.log(this.props.fullData)
        if (type == 'in') {
            hasDestination = true
        }

        if (type == 'out') {
            hasSource = true
        }

        if (type == 'transfer') {
            hasSource = true
            hasDestination = true
        }

        if (type == 'adjustment') {
            hasSource = true
            // hasDestination = true
        }

        // console.log(hasDestination, hasSource)
        this.setState({ hasDestination, hasSource }, () => this.createFields)
    }


    getWarehouseSections = (id, key) => {

        let body = { id }
        let items = []
        let promises = []

        if (id) {
            promises.push(new Promise((resolve, reject) => {

                HttpServices.request("getWarehouseSections", body, (fetchResult, fetchError) => {
                    if (fetchError) { resolve(); return }

                    if (Array.isArray(fetchResult.info)) {
                        for (let i = 0; i < fetchResult.info.length; i++) {
                            const element = fetchResult.info[i];
                            items.push({ value: element._id, title: element.name })
                        }
                    }

                    resolve();

                })

            }))
        }

        Promise.all(promises).then(() => {

            this.setState({ [key]: items }, () => {
                this.createFields()
            })

        })

    }


    createFields = () => {

        let fields = deepInstantOfObject(this.state.baseFields)

        if (this.state.relatedFields?.type == "in" || this.state.relatedFields?.type == "out" || this.state.relatedFields?.type == "transfer") {
            fields.push(deepInstantOfObject(this.state.allFields.quantity))
        }


        if (this.state.relatedFields?.type == "in") {
            fields.push(deepInstantOfObject(this.state.allFields.costPerUnit))
        }

        if (this.state.hasSource) {
            if (this.state.sourceSections && this.state.sourceSections?.length > 0) {
                let sourceSection = deepInstantOfObject(this.state.allFields.sourceSection)
                sourceSection.information.items = this.state.sourceSections

                if (this.state.relatedFields?.type == "adjustment") {
                    sourceSection.information.label = '{{lang}}Section'
                }
                fields.push(sourceSection)
                // fields.push(this.state.allFields.sourceSection)
            }
            let statusField = deepInstantOfObject(this.state.allFields.sourceStatus)
            if (this.state.relatedFields?.type == "adjustment") {
                statusField.information.label = '{{lang}}Status'
            }
            fields.push(statusField)
        }


        if (this.state.hasDestination) {
            if (this.state.destinationSections && this.state.destinationSections?.length > 0) {
                let destinationSection = deepInstantOfObject(this.state.allFields.destinationSection)
                destinationSection.information.items = this.state.destinationSections
                fields.push(destinationSection)
            }
            fields.push(deepInstantOfObject(this.state.allFields.destinationStatus))
        }

        // console.log(this.state.relatedFields?.type)
        if (this.state.relatedFields?.type == "transfer") {
            fields.push(deepInstantOfObject(this.state.allFields.valueAdjustment))
        }

        if (this.state.relatedFields?.type == "adjustment") {

            if (this.state.relatedFields?.subType == "value") {
                fields.push(deepInstantOfObject(this.state.allFields.valueAdjustment))
            } else {
                fields.push(deepInstantOfObject(this.state.allFields.quantityAdjustment))

                let showCostPerUnit = false

                if (Array.isArray(this.props.data)) {
                    for (let m = 0; m < this.props.data.length; m++) {
                        const element = this.props.data[m];
                        if (element.quantityAdjustment > 0) {
                            showCostPerUnit = true
                        }
                    }
                }

                if (showCostPerUnit) {
                    fields.push(deepInstantOfObject(this.state.allFields.costPerUnit))
                }

            }
        }

        let colSize = '4'
        let firstCol = '4'
        // console.log(12 % fields.length, fields.length)
        let remain = 12 % fields.length


        if (fields.length > 6) {
            colSize = `1_5`
            firstCol = `3`

        } else {
            colSize = `${(12 - remain) / fields.length}`
            firstCol = `${remain + Number(colSize)}`

        }
        // if (12 % fields.length == 0) {
        //     colSize = `${12 / fields.length}`
        //     firstCol = colSize
        // } else {
        //     colSize = '3'//`${12 / fields.length}`
        //     firstCol = '3'
        // }

        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            if (i == 0) {
                field.col = firstCol
            } else {
                field.col = colSize
            }
        }


        // console.log(fields)


        this.setState({ fields })
    }



    validator() {
        let valid = true

        return valid
    }




    functionsHandler = (type, name, data, extra, cb) => {

        if (this[name]) {
            this[name](data, extra, cb)
        }
    }




    changeValue = (key, value, extra) => {

        this.calculateTotals(value)
        this.props.changeValue(this.props.header?.key, value, this.props.extra)

        if (this.state.relatedFields?.type == "adjustment" && this.state.relatedFields?.subType == "quantity" && key == 'quantityAdjustment') {
            setTimeout(() => {
                this.createFields()
            }, 100);
        }

    }


    calculateTotals = (entries) => {


        if (this.state.relatedFields?.type == "adjustment") {

            let totalAdjustment = 0

            if (Array.isArray(entries)) {



                for (let i = 0; i < entries.length; i++) {
                    const single = entries[i];

                    if (this.state.relatedFields?.subType == "value") {

                        totalAdjustment += (single.quantity ?? 0) * (single.valueAdjustment ?? 0)

                    } else {

                        totalAdjustment += (single.quantityAdjustment ?? 0)

                    }
                }



                this.setState({ totalAdjustment })
            }

        } else {
            let totalQuantity = 0
            let totalValue = 0
            let totalAdjustment = 0

            if (Array.isArray(entries)) {



                for (let i = 0; i < entries.length; i++) {
                    const single = entries[i];
                    totalQuantity += (single.quantity ?? 0)
                    totalValue += (single.quantity ?? 0) * (single.costPerUnit ?? 0)

                    if (this.state.relatedFields?.type == "transfer") {
                        totalAdjustment += (single.quantity ?? 0) * (single.valueAdjustment ?? 0)

                    }

                }
            }

            // let different = debitTotal - creditTotal

            this.setState({ totalQuantity, totalValue, totalAdjustment })
        }
    }



    setFetchedData = (key, data) => {
        // console.log("setFetchedData")
        let fetchedData = this.state.fetchedData
        if (!fetchedData) {
            fetchedData = {}
        }

        fetchedData[key] = data


        // console.log("fetchedData", fetchedData)


        this.setState({ fetchedData })
    }





    render() {

        if (this.state.show) {

            return (
                <div className="w-100 subform  pt-0" ref={(el) => this.form = el}>

                    <SubformInput header={{ information: { headers: this.state.fields } }} data={this.props.data} top={0} functionsHandler={this.functionsHandler} changeValue={this.changeValue} inputClass={this.props.inputClass} variables={this.props.variables} params={this.props.params} width={this.props.width} setFetchedData={this.setFetchedData} fetchedData={this.state.fetchedData} />

                    <div className="d-flex  justify-content-end mt-3 mb-4">
                        <div className="d-flex" style={{ backgroundColor: '#f6f6f6', borderRadius: 8, padding: '15px 20px' }}>
                            {this.state.relatedFields?.type == "adjustment" ?
                                (

                                    <div className="text-center" style={{ maxWidth: '250px', width: '100%', color: '#000' }}>
                                        {this.state.relatedFields?.subType == "value" ? (
                                            <p className="text-small text-end mb-2">{translate("Total Value Adjustment")}</p>

                                        ) : (
                                            <p className="text-small text-end mb-2">{translate("Total Quantity Adjustment")}</p>

                                        )}
                                    </div>
                                ) : (
                                    <div className="text-center" style={{ maxWidth: '250px', width: '100%', color: '#000' }}>
                                        <p className="text-small text-end mb-2">{translate("Total Quantity")}</p>
                                        {this.state.relatedFields?.type == "transfer" ? (
                                            <p className="text-small text-end mb-2">{translate("Total Value Adjustment")}</p>
                                        ) : (
                                            <p className="text-small text-end mb-2">{translate("Total Value")}</p>

                                        )}
                                        {/* <p className="text-small text-end mb-2" style={{ color: '#ee5050' }}>{translate("Difference")}</p> */}
                                    </div>
                                )}


                            {this.state.relatedFields?.type == "adjustment" ? (

                                <div className="text-center" style={{ width: '150px' }}>
                                    <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.totalAdjustment) ?? 0}</p>
                                </div>

                            ) : (

                                <div className="text-center" style={{ width: '150px' }}>

                                    <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.totalQuantity) ?? 0}</p>

                                    {this.state.relatedFields?.type == "transfer" ? (
                                        <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.totalAdjustment) ?? 0}</p>
                                    ) : (
                                        <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.totalValue) ?? 0}</p>

                                    )}

                                    {/* <p className="text-small text-end mb-2">{priceStandardView(this.state.totalquantity)}</p>
                                {this.state.different < 0 && (
                                    <p className="text-small text-end mb-2" style={{ color: this.state.different != 0 ? '#ee5050' : '#000' }}>{priceStandardView(Math.abs(this.state.different))}</p>
                                )} */}
                                </div>
                            )}


                            {/* <div className="text-center" style={{ width: '150px' }}>
                                <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.totalQuantity)}</p>
                                <p className="text-small text-end mb-2">{priceStandardView(this.state.totalValue)}</p>
                                {this.state.different >= 0 && (
                                    <p className="text-small text-end mb-2" style={{ color: this.state.different != 0 ? '#ee5050' : '#000' }}>{priceStandardView(this.state.different)}</p>
                                )}
                            </div> */}

                        </div>
                    </div>

                </div>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default InventoryInput;